import { DateTime } from 'luxon';

export const COLUMN_TYPES = [
  'text',
  'number',
  'date',
  'dateTime',
  'yes-no',
];

const dateParser = (format) => (value) => {
  if (!value) return null;
  const timezone = DateTime.local().zoneName;
  return DateTime.fromFormat(value, format, { zone: timezone }).toMillis();
};

const floatParser = (value) => {
  if (!value) return null;
  const floatValue = Number.parseFloat(value);
  return Number.isNaN(floatValue) ? null : floatValue;
};

const dateRender = (format) => (value) => (
  value ? DateTime.fromMillis(value).toLocaleString(format) : null
);

export const WORK_ORDER_15 = [
  {
    title: 'Record Type',
    index: 0,
    length: 2,
    dataIndex: 'recordType',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contract Number',
    index: 2,
    length: 7,
    dataIndex: 'maintenanceContractNumber',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contractor Description',
    index: 9,
    length: 30,
    dataIndex: 'maintenanceContractorDescription',
    width: 250,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'File Creation Date/Time',
    index: 39,
    length: 14,
    dataIndex: 'fileCreationDateTime',
    width: 200,
    render: dateRender(DateTime.DATETIME_MED),
    parser: dateParser('yyyyMMdd:HH:mm'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Work Order Number',
    index: 53,
    length: 10,
    dataIndex: 'workOrderNumber',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Revision Number',
    index: 63,
    length: 2,
    dataIndex: 'revisionNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Work Order Date',
    index: 65,
    length: 8,
    dataIndex: 'workOrderDate',
    width: 100,
    render: dateRender(DateTime.DATE_MED),
    parser: dateParser('yyyyMMdd'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Fiscal Year',
    index: 73,
    length: 8,
    dataIndex: 'fiscalYear',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'From Inspector',
    index: 81,
    length: 30,
    dataIndex: 'fromInspector',
    width: 200,
    validTypes: ['text', 'attribute', 'calculation'],
  },
];

export const WORK_ORDER_20 = [
  {
    title: 'Record Type',
    index: 0,
    length: 2,
    dataIndex: 'recordType',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contract Number',
    index: 2,
    length: 7,
    dataIndex: 'maintenanceContractNumber',
    width: 100,
    validTypes: ['number'],
  },
  {
    title: 'Maintenance Contractor Description',
    index: 9,
    length: 30,
    dataIndex: 'maintenanceContractorDescription',
    width: 250,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'File Creation Date/Time',
    index: 39,
    length: 14,
    dataIndex: 'fileCreationDateTime',
    width: 200,
    render: dateRender(DateTime.DATETIME_MED),
    parser: dateParser('yyyyMMdd:HH:mm'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Work Order Item Number',
    index: 53,
    length: 2,
    dataIndex: 'workOrderItemNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Work Order Activity Number',
    index: 55,
    length: 4,
    dataIndex: 'workOrderActivityNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Work Order Activity Description',
    index: 59,
    length: 40,
    dataIndex: 'workOrderActivityDescription',
    width: 200,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Activity Due Date',
    index: 99,
    length: 8,
    dataIndex: 'activityDueDate',
    width: 150,
    render: dateRender(DateTime.DATE_MED),
    parser: dateParser('yyyyMMdd'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Inspection Type',
    index: 107,
    length: 12,
    dataIndex: 'inspectionType',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Warranty Type',
    index: 119,
    length: 12,
    dataIndex: 'warrantyType',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'MMS Unit of Measure',
    index: 131,
    length: 5,
    dataIndex: 'mmsUnitOfMeasure',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Inspector Remarks',
    index: 136,
    length: undefined,
    dataIndex: 'inspectorRemarks',
    width: 200,
    validTypes: ['text', 'attribute', 'calculation'],
  },
];

export const WORK_ORDER_22 = [
  {
    title: 'Record Type',
    index: 0,
    length: 2,
    dataIndex: 'recordType',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contract Number',
    index: 2,
    length: 7,
    dataIndex: 'maintenanceContractNumber',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contractor Description',
    index: 9,
    length: 30,
    dataIndex: 'maintenanceContractorDescription',
    width: 250,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'File Creation Date/Time',
    index: 39,
    length: 14,
    dataIndex: 'fileCreationDateTime',
    width: 200,
    render: dateRender(DateTime.DATETIME_MED),
    parser: dateParser('yyyyMMdd:HH:mm'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Work Order Item Number',
    index: 53,
    length: 2,
    dataIndex: 'workOrderItemNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Work Order Activity Number',
    index: 55,
    length: 4,
    dataIndex: 'workOrderActivityNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Road Segment Identifier',
    index: 59,
    length: 8,
    dataIndex: 'roadSegmentIdentifier',
    width: 200,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Road Segment Description',
    index: 67,
    length: 40,
    dataIndex: 'roadSegmentDescription',
    width: 200,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Activity Due Date',
    index: 107,
    length: 8,
    dataIndex: 'activityDueDate',
    width: 150,
    render: dateRender(DateTime.DATE_MED),
    parser: dateParser('yyyyMMdd'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Inspection Type',
    index: 115,
    length: 12,
    dataIndex: 'inspectionType',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
];

export const WORK_ORDER_25 = [
  {
    title: 'Record Type',
    index: 0,
    length: 2,
    dataIndex: 'recordType',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contract Number',
    index: 2,
    length: 7,
    dataIndex: 'maintenanceContractNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contractor Description',
    index: 9,
    length: 30,
    dataIndex: 'maintenanceContractorDescription',
    width: 250,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'File Creation Date/Time',
    index: 39,
    length: 14,
    dataIndex: 'fileCreationDateTime',
    width: 200,
    render: dateRender(DateTime.DATETIME_MED),
    parser: dateParser('yyyyMMdd:HH:mm'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Work Order Item Number',
    index: 53,
    length: 2,
    dataIndex: 'workOrderItemNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Work Order Activity Number',
    index: 55,
    length: 4,
    dataIndex: 'workOrderActivityNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Bid Item Number',
    index: 59,
    length: 4,
    dataIndex: 'bidItemNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Bid Item Description',
    index: 63,
    length: 40,
    dataIndex: 'bidItemDescription',
    width: 200,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Authorized Quantity',
    index: 103,
    length: 9,
    dataIndex: 'authorizedQuantity',
    width: 20,
    parser: floatParser,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'MMS Unit of Measure',
    index: 112,
    length: 5,
    dataIndex: 'mmsUnitOfMeasure',
    width: 100,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Supplemental Bid Item',
    index: 117,
    length: 1,
    dataIndex: 'supplementalBidItem',
    width: 20,
    validTypes: ['yes-no'],
  },
];

export const WORK_ORDER_95 = [
  {
    title: 'Record Type',
    index: 0,
    length: 2,
    dataIndex: 'recordType',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Maintenance Contract Number',
    index: 2,
    length: 7,
    dataIndex: 'maintenanceContractNumber',
    width: 20,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'File Creation Date/Time',
    index: 9,
    length: 14,
    dataIndex: 'fileCreationDateTime',
    width: 150,
    render: dateRender(DateTime.DATETIME_MED),
    parser: dateParser('yyyyMMdd:HH:mm'),
    validTypes: ['dateTime'],
  },
  {
    title: 'Number of Type 15 Records in File',
    index: 23,
    length: 4,
    dataIndex: 'numberOfType15RecordsInFile',
    width: 20,
    parser: floatParser,
    validTypes: ['number'],
  },
  {
    title: 'Number of Type 20 Records in File',
    index: 27,
    length: 4,
    dataIndex: 'numberOfType20RecordsInFile',
    width: 20,
    parser: floatParser,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Number of Type 22 Records in File',
    index: 31,
    length: 4,
    dataIndex: 'numberOfType22RecordsInFile',
    width: 20,
    parser: floatParser,
    validTypes: ['text', 'attribute', 'calculation'],
  },
  {
    title: 'Number of Type 25 Records in File',
    index: 35,
    length: 4,
    dataIndex: 'numberOfType25RecordsInFile',
    width: 20,
    parser: floatParser,
    validTypes: ['text', 'attribute', 'calculation'],
  },
];

export const WORK_ORDER_62 = [
  {
    title: 'Record Type',
    index: 0,
    length: 2,
    dataIndex: 'recordType',
    width: 20,
  },
  {
    title: 'Maintenance Contract Number',
    index: 2,
    length: 7,
    dataIndex: 'maintenanceContractNumber',
    width: 20,
  },
  {
    title: 'Maintenance Contractor Description',
    index: 9,
    length: 30,
    dataIndex: 'maintenanceContractorDescription',
    width: 250,
  },
  {
    title: 'File Creation Date/Time',
    index: 39,
    length: 14,
    dataIndex: 'fileCreationDateTime',
    width: 150,
    render: dateRender(DateTime.DATETIME_MED),
    parser: dateParser('yyyyMMdd:HH:mm'),
  },
  {
    title: 'Batch Transfer Sequence',
    index: 53,
    length: 8,
    dataIndex: 'batchTransferSequence',
    width: 20,
  },
  {
    title: 'Crewsheet Invoice #',
    index: 61,
    length: 6,
    dataIndex: 'crewsheetInvoiceNumber',
    width: 20,
  },
  {
    title: 'Accept/Reject Status',
    index: 67,
    length: 1,
    dataIndex: 'acceptRejectStatus',
    width: 20,
  },
];

export const WORK_ORDER_97 = [
  {
    title: 'Record Type',
    index: 0,
    length: 2,
    dataIndex: 'recordType',
    width: 20,
  },
  {
    title: 'Maintenance Contract Number',
    index: 2,
    length: 7,
    dataIndex: 'maintenanceContractNumber',
    width: 20,
  },
  {
    title: 'Maintenance Contractor Description',
    index: 9,
    length: 30,
    dataIndex: 'maintenanceContractorDescription',
    width: 250,
  },
  {
    title: 'File Creation Date/Time',
    index: 39,
    length: 14,
    dataIndex: 'fileCreationDateTime',
    width: 150,
    render: dateRender(DateTime.DATETIME_MED),
    parser: dateParser('yyyyMMdd:HH:mm'),
  },
  {
    title: 'Batch Transfer Sequence',
    index: 53,
    length: 8,
    dataIndex: 'batchTransferSequence',
    width: 20,
  },
  {
    title: 'Number of Records',
    index: 61,
    length: 4,
    dataIndex: 'numberOfRecords',
    width: 20,
    parser: floatParser,
  },
];
export const WORK_ORDER_TYPES = {
  15: WORK_ORDER_15,
  20: WORK_ORDER_20,
  22: WORK_ORDER_22,
  25: WORK_ORDER_25,
  95: WORK_ORDER_95,
  62: WORK_ORDER_62,
  97: WORK_ORDER_97,
};

export const RECORD_TYPE_OPTIONS = [
  {
    title: 'Record Type 20: Work Order Items',
    id: '20',
  },
  {
    title: 'Record Type 22: Work Order Segments',
    id: '22',
  },
  {
    title: 'Record Type 25: Work Order Bid Items',
    id: '25',
  },
];

export const ACCEPT_REJECT_TYPES = new Set([62, 97]);
